<template>
	<div class="app-icon" v-on="$listeners">
		<svg
			xmlns="http://www.w3.org/2000/svg"
			:viewBox="icon.viewBox"
			:aria-labelledby="iconName"
			role="presentation"
		>
			<title
				:id="iconName"
				lang="en"
			>
				{{ iconName }} icon
			</title>

			<g :fill="iconColor">
				<slot>
					<path
						v-if="iconName"
						:d="icon.d"
						:transform="icon.transform"
					/>
				</slot>
			</g>
		</svg>
	</div>
</template>

<script>
const icons = {
	dashboard: {
		d: 'M10.353,10.4c-.585,0-1.059.313-1.059.7v4.2c0,.387.474.7,1.059.7s1.059-.313,1.059-.7V11.1C11.412,10.713,10.938,10.4,10.353,10.4ZM5.059,13.2c-.585,0-1.059.313-1.059.7v1.4c0,.387.474.7,1.059.7s1.059-.313,1.059-.7V13.9C6.118,13.513,5.644,13.2,5.059,13.2ZM20.941,2c-.585,0-1.059.313-1.059.7V15.3c0,.387.474.7,1.059.7S22,15.687,22,15.3V2.7C22,2.313,21.526,2,20.941,2ZM15.647,6.9c-.585,0-1.059.313-1.059.7v7.7c0,.387.474.7,1.059.7s1.059-.313,1.059-.7V7.6C16.706,7.213,16.232,6.9,15.647,6.9Z',
		transform: 'translate(-4 -2)',
		viewBox: '0 0 18 14'
	},

	user: {
		d: 'M13.529,11.252a3.357,3.357,0,0,0,.9-2.25,3.4,3.4,0,1,0-6.8,0,3.357,3.357,0,0,0,.9,2.25A5.346,5.346,0,0,0,5.6,15.4a.905.905,0,1,0,1.8.2,3.6,3.6,0,0,1,7.146,0,.9.9,0,0,0,.954.8h.1a.9.9,0,0,0,.792-.99,5.346,5.346,0,0,0-2.862-4.158ZM11,10.6A1.6,1.6,0,1,1,12.6,9,1.6,1.6,0,0,1,11,10.6ZM17.3,2H4.7A2.7,2.7,0,0,0,2,4.7V17.3A2.7,2.7,0,0,0,4.7,20H17.3A2.7,2.7,0,0,0,20,17.3V4.7A2.7,2.7,0,0,0,17.3,2Zm.9,15.3a.9.9,0,0,1-.9.9H4.7a.9.9,0,0,1-.9-.9V4.7a.9.9,0,0,1,.9-.9H17.3a.9.9,0,0,1,.9.9Z',
		transform: 'translate(-2 -2)',
		viewBox: '0 0 18 18'
	},

	message: {
		d: 'M17.3,4H4.7A2.7,2.7,0,0,0,2,6.7v9a2.7,2.7,0,0,0,2.7,2.7H17.3A2.7,2.7,0,0,0,20,15.7v-9A2.7,2.7,0,0,0,17.3,4ZM4.7,5.8H17.3a.9.9,0,0,1,.9.9L11,11.092,3.8,6.7A.9.9,0,0,1,4.7,5.8Zm13.5,9.9a.9.9,0,0,1-.9.9H4.7a.9.9,0,0,1-.9-.9V8.752l6.732,4.113a.9.9,0,0,0,.9,0L18.2,8.752Z',
		transform: 'translate(-2 -4)',
		viewBox: '0 0 18 14.4'
	},

	sticker: {
		d: 'M17.717,4.413A.783.783,0,0,0,18.5,3.63V1.283A.783.783,0,0,0,17.717.5H15.37a.783.783,0,0,0-.783.783.391.391,0,0,1-.783,0A.783.783,0,0,0,13.022.5H10.674a.783.783,0,0,0-.783.783.391.391,0,1,1-.783,0A.783.783,0,0,0,8.326.5H5.978a.783.783,0,0,0-.783.783.391.391,0,0,1-.783,0A.783.783,0,0,0,3.63.5H1.283A.783.783,0,0,0,.5,1.283V3.63a.783.783,0,0,0,.783.783.391.391,0,1,1,0,.783A.783.783,0,0,0,.5,5.978V8.326a.783.783,0,0,0,.783.783.391.391,0,1,1,0,.783.783.783,0,0,0-.783.783v2.348a.783.783,0,0,0,.783.783.391.391,0,1,1,0,.783A.783.783,0,0,0,.5,15.37v2.348a.783.783,0,0,0,.783.783H3.63a.783.783,0,0,0,.783-.783.391.391,0,0,1,.783,0,.783.783,0,0,0,.783.783H8.326a.783.783,0,0,0,.783-.783.391.391,0,0,1,.783,0,.783.783,0,0,0,.783.783h2.348a.783.783,0,0,0,.783-.783.391.391,0,0,1,.783,0,.783.783,0,0,0,.783.783h2.348a.783.783,0,0,0,.783-.783V15.37a.783.783,0,0,0-.783-.783.391.391,0,0,1,0-.783.783.783,0,0,0,.783-.783V10.674a.783.783,0,0,0-.783-.783.391.391,0,0,1,0-.783.783.783,0,0,0,.783-.783V5.978a.783.783,0,0,0-.783-.783.391.391,0,0,1,0-.783Zm-.783-1.4a1.957,1.957,0,0,0,0,3.584V7.708a1.957,1.957,0,0,0,0,3.584V12.4a1.957,1.957,0,0,0,0,3.584v.947h-.947a1.957,1.957,0,0,0-3.584,0H11.292a1.957,1.957,0,0,0-3.584,0H6.6a1.957,1.957,0,0,0-3.584,0H2.065v-.947a1.957,1.957,0,0,0,0-3.584V11.292a1.957,1.957,0,0,0,0-3.584V6.6a1.957,1.957,0,0,0,0-3.584V2.065h.947a1.957,1.957,0,0,0,3.584,0H7.708a1.957,1.957,0,0,0,3.584,0H12.4a1.957,1.957,0,0,0,3.584,0h.947ZM9.5,4.022a5.478,5.478,0,0,0,0,10.957,5.423,5.423,0,0,0,2.739-.736.783.783,0,1,0-.783-1.354A3.913,3.913,0,1,1,13.413,9.5v.391a.65.65,0,0,1-.65.65.657.657,0,0,1-.657-.65V7.677a.783.783,0,0,0-1.393-.47A2.543,2.543,0,0,0,9.5,6.894a2.606,2.606,0,1,0,0,5.212,2.567,2.567,0,0,0,1.7-.642A2.223,2.223,0,0,0,14.978,9.9V9.5A5.478,5.478,0,0,0,9.5,4.022Zm0,6.519a1.033,1.033,0,1,1,.738-.3A1.041,1.041,0,0,1,9.5,10.541Z',
		transform: 'translate(-0.5 -0.5)',
		viewBox: '0 0 18 18'
	},

	order: {
		d: 'M19.074,14.581H6.493a.9.9,0,0,1,0-1.8h9.382a2.7,2.7,0,0,0,2.615-2.04l1.483-5.832a.893.893,0,0,0-.9-1.114H6.277A2.7,2.7,0,0,0,3.743,2H2.9a.9.9,0,0,0,0,1.8h.845a.9.9,0,0,1,.9.683l.054.431h0L6.25,10.986a2.7,2.7,0,0,0,.243,5.392h.162a2.7,2.7,0,1,0,5.068,0h2.121a2.7,2.7,0,1,0,5.068,0h.162a.9.9,0,1,0,0-1.8Zm-1.15-8.986L16.746,10.3a.9.9,0,0,1-.9.683H8.093L6.745,5.594ZM9.189,18.175a.9.9,0,1,1,.9-.9A.9.9,0,0,1,9.189,18.175Zm7.189,0a.9.9,0,1,1,.9-.9A.9.9,0,0,1,16.378,18.175Z',
		transform: 'translate(-2 -2)',
		viewBox: '0 0 18 17.994'
	},

	notification: {
		d: 'M19.75,14.578V11a6.75,6.75,0,0,0-5.625-6.649V3.125a1.125,1.125,0,1,0-2.25,0V4.351A6.75,6.75,0,0,0,6.25,11v3.577A3.375,3.375,0,0,0,4,17.75V20a1.125,1.125,0,0,0,1.125,1.125H8.658a4.5,4.5,0,0,0,8.685,0h3.533A1.125,1.125,0,0,0,22,20V17.75a3.375,3.375,0,0,0-2.25-3.172ZM8.5,11a4.5,4.5,0,1,1,9,0v3.375h-9ZM13,22.25a2.25,2.25,0,0,1-1.935-1.125h3.87A2.25,2.25,0,0,1,13,22.25Zm6.75-3.375H6.25V17.75a1.125,1.125,0,0,1,1.125-1.125h11.25A1.125,1.125,0,0,1,19.75,17.75Z',
		transform: 'translate(-4 -2)',
		viewBox: '0 0 18 22.445'
	},

	ecosystem: {
		d: 'M2.9,11.2H8.3a.9.9,0,0,0,.9-.9V4.9A.9.9,0,0,0,8.3,4H2.9a.9.9,0,0,0-.9.9v5.4a.9.9,0,0,0,.9.9Zm.9-5.4H7.4V9.4H3.8Zm8.1,1.8h7.2a.9.9,0,1,0,0-1.8H11.9a.9.9,0,0,0,0,1.8Zm0,9h-9a.9.9,0,1,0,0,1.8h9a.9.9,0,1,0,0-1.8ZM19.1,13H2.9a.9.9,0,1,0,0,1.8H19.1a.9.9,0,1,0,0-1.8Zm0-3.6H11.9a.9.9,0,1,0,0,1.8h7.2a.9.9,0,1,0,0-1.8Z',
		transform: 'translate(-2 -4)',
		viewBox: '0 0 18 14.4'
	},

	navigationExpanded: {
		d: 'M10,13H3a1,1,0,0,0-1,1v7a1,1,0,0,0,1,1h7a1,1,0,0,0,1-1V14A1,1,0,0,0,10,13ZM9,20H4V15H9ZM21,2H14a1,1,0,0,0-1,1v7a1,1,0,0,0,1,1h7a1,1,0,0,0,1-1V3A1,1,0,0,0,21,2ZM20,9H15V4h5Zm1,4H14a1,1,0,0,0-1,1v7a1,1,0,0,0,1,1h7a1,1,0,0,0,1-1V14A1,1,0,0,0,21,13Zm-1,7H15V15h5ZM10,2H3A1,1,0,0,0,2,3v7a1,1,0,0,0,1,1h7a1,1,0,0,0,1-1V3A1,1,0,0,0,10,2ZM9,9H4V4H9Z',
		transform: 'translate(-2 -2)',
		viewBox: '0 0 20 20'
	},

	navigationShrink: {
		d: 'M21,2H3A1,1,0,0,0,2,3V21a1,1,0,0,0,1,1H21a1,1,0,0,0,1-1V3A1,1,0,0,0,21,2ZM8,20H4V4H8Zm12,0H10V4H20Z',
		transform: 'translate(-2 -2)',
		viewBox: '0 0 20 20'
	},

	android: {
		d: 'M2.992,9a1,1,0,0,0-1,1v4a1,1,0,0,0,2,0V10a1,1,0,0,0-1-1Zm18,0a1,1,0,0,0-1,1v4a1,1,0,1,0,2,0V10a1,1,0,0,0-1-1ZM16.857,3.5a1,1,0,1,0-1.731-1l-.614,1.062a5.928,5.928,0,0,0-5.04,0L8.857,2.5a1,1,0,1,0-1.731,1l.693,1.2A5.979,5.979,0,0,0,5.992,9v8a1,1,0,0,0,1,1h2v3a1,1,0,0,0,2,0V18h2v3a1,1,0,0,0,2,0V18h2a1,1,0,0,0,1-1V9a5.979,5.979,0,0,0-1.827-4.3ZM15.992,16h-8V11h8Zm-8-7a4,4,0,1,1,8,0Z',
		transform: 'translate(-1.992 -2.001)',
		viewBox: '0 0 20 20'
	},

	apple: {
		d: 'M20.5,15.744a3.386,3.386,0,0,1-2.055-3.127A3.5,3.5,0,0,1,20.137,9.67a1,1,0,0,0,.3-1.415A5.574,5.574,0,0,0,16.421,5.87a6.422,6.422,0,0,0,.965-3.977A.984.984,0,0,0,16.353,1a6.691,6.691,0,0,0-4.443,2.261,6.842,6.842,0,0,0-1.479,2.9,5.264,5.264,0,0,0-1.62-.277A5.925,5.925,0,0,0,3.819,8.892c-1.888,3.277-.733,8.188,1.312,11.145C5.951,21.221,7.182,23,9.039,23c.037,0,.074,0,.111,0a4.74,4.74,0,0,0,1.792-.464,3.274,3.274,0,0,1,1.445-.354,3.045,3.045,0,0,1,1.357.338,4.752,4.752,0,0,0,1.962.456c1.913-.036,3.043-1.687,3.868-2.893a12.042,12.042,0,0,0,1.513-3.108,1,1,0,0,0-.583-1.229ZM13.423,4.568a4.941,4.941,0,0,1,1.919-1.322A4.855,4.855,0,0,1,14.306,5.4a4.391,4.391,0,0,1-1.264,1.04h0l-.085.034c-.187.073-.417.164-.595.223a4.825,4.825,0,0,1,1.064-2.127Zm4.5,14.385c-.8,1.174-1.436,2.007-2.254,2.021a2.367,2.367,0,0,1-1.131-.292,4.969,4.969,0,0,0-2.151-.5,5.214,5.214,0,0,0-2.229.513A2.885,2.885,0,0,1,9.073,21h-.03c-.813,0-1.687-1.263-2.268-2.1C5.323,16.8,3.983,12.615,5.552,9.89A3.917,3.917,0,0,1,8.843,7.884h.034a4.758,4.758,0,0,1,1.641.444c.131.052.261.1.389.151.033.014.066.026.1.037a3.315,3.315,0,0,0,1.117.237,4.436,4.436,0,0,0,1.564-.421,4.956,4.956,0,0,1,2.223-.5,3.787,3.787,0,0,1,2.25.854,5.31,5.31,0,0,0-1.712,3.945h0a5.3,5.3,0,0,0,2.451,4.5A10.2,10.2,0,0,1,17.925,18.953Z',
		transform: 'translate(-2.862 -1)',
		viewBox: '0 0 18.271 21.999'
	},

	registered: {
		d: 'M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8,8,0,0,1,12,20Zm.5-13h-3a1,1,0,0,0-1,1v8a1,1,0,0,0,2,0V14h2a1,1,0,0,1,1,1v1a1,1,0,0,0,2,0V15a3,3,0,0,0-.78-2,3,3,0,0,0,.78-2V10a3,3,0,0,0-3-3Zm1,4a1,1,0,0,1-1,1h-2V9h2a1,1,0,0,1,1,1Z',
		transform: 'translate(-2 -2)',
		viewBox: '0 0 20 20'
	},

	search: {
		d: 'm44.498 44.415c-1.6691 1.6691-4.3745 1.6691-6.0438 0l-7.5415-7.5416c-3.1005 1.989-6.7655 3.1741-10.723 3.1741-11.012 0-19.941-8.9273-19.941-19.941s8.9285-19.941 19.941-19.941c11.014 0 19.941 8.927 19.941 19.941 0 3.9559-1.1866 7.6223-3.1742 10.724l7.5416 7.5416c1.6691 1.6691 1.6691 4.3731 0 6.0422zm-24.308-38.551c-7.8658 0-14.243 6.376-14.243 14.243s6.3775 14.243 14.243 14.243c7.8671 0 14.243-6.3761 14.243-14.243s-6.3761-14.243-14.243-14.243z',
		viewBox: '0 0 46 46'
	},

	check: {
		d: 'M14.72,8.79l-4.29,4.3L8.78,11.44a1,1,0,1,0-1.41,1.41l2.35,2.36a1,1,0,0,0,1.41,0l5-5a1,1,0,1,0-1.41-1.42Z',
		transform: 'translate(-7.02 -8.499)',
		viewBox: '0 0 9.405 7.001'
	},

	calendar: {
		d: 'M9.5,14.5a.75.75,0,1,0-.75-.75A.75.75,0,0,0,9.5,14.5Zm3.75,0a.75.75,0,1,0-.75-.75A.75.75,0,0,0,13.25,14.5Zm0-3a.75.75,0,1,0-.75-.75A.75.75,0,0,0,13.25,11.5Zm-3.75,0a.75.75,0,1,0-.75-.75A.75.75,0,0,0,9.5,11.5Zm5.25-9H14V1.75a.75.75,0,1,0-1.5,0V2.5h-6V1.75a.75.75,0,0,0-1.5,0V2.5H4.25A2.25,2.25,0,0,0,2,4.75v10.5A2.25,2.25,0,0,0,4.25,17.5h10.5A2.25,2.25,0,0,0,17,15.25V4.75A2.25,2.25,0,0,0,14.75,2.5Zm.75,12.75a.75.75,0,0,1-.75.75H4.25a.75.75,0,0,1-.75-.75V8.5h12ZM15.5,7H3.5V4.75A.75.75,0,0,1,4.25,4H5v.75a.75.75,0,1,0,1.5,0V4h6v.75a.75.75,0,1,0,1.5,0V4h.75a.75.75,0,0,1,.75.75ZM5.75,11.5A.75.75,0,1,0,5,10.75.75.75,0,0,0,5.75,11.5Zm0,3A.75.75,0,1,0,5,13.75.75.75,0,0,0,5.75,14.5Z',
		transform: 'translate(-2 -1)',
		viewBox: '0 0 15 16.5'
	},

	clock: {
		d: 'M8.5,2A7.5,7.5,0,1,0,16,9.5,7.5,7.5,0,0,0,8.5,2Zm0,13.5a6,6,0,1,1,6-6A6,6,0,0,1,8.5,15.5ZM8.5,5a.75.75,0,0,0-.75.75v3H6.25a.75.75,0,1,0,0,1.5H8.5a.75.75,0,0,0,.75-.75V5.75A.75.75,0,0,0,8.5,5Z',
		transform: 'translate(-1 -2)',
		viewBox: '0 0 15 15'
	},

	arrowLeft: {
		d: 'M17,11H9.41l3.3-3.29a1,1,0,1,0-1.42-1.42l-5,5a1.034,1.034,0,0,0,0,1.42l5,5a1,1,0,1,0,1.42-1.42L9.41,13H17a1,1,0,0,0,0-2Z',
		transform: 'translate(-6.005 -5.996)',
		viewBox: '0 0 11.995 12.01'
	},

	edit: {
		d: 'M5,18H9.24a1,1,0,0,0,.71-.29l6.92-6.93h0L19.71,8a1,1,0,0,0,0-1.42L15.47,2.29a1,1,0,0,0-1.42,0L11.23,5.12h0L4.29,12.05a1,1,0,0,0-.29.71V17A1,1,0,0,0,5,18ZM14.76,4.41l2.83,2.83L16.17,8.66,13.34,5.83ZM6,13.17l5.93-5.93,2.83,2.83L8.83,16H6ZM21,20H3a1,1,0,0,0,0,2H21a1,1,0,0,0,0-2Z',
		viewBox: '0 0 20 20.006',
		transform: 'translate(-2 -1.994)'
	},

	delete: {
		d: 'M16.6,5.2H13.4V4.4A2.4,2.4,0,0,0,11,2H9.4A2.4,2.4,0,0,0,7,4.4v.8H3.8a.8.8,0,1,0,0,1.6h.8v8.8A2.4,2.4,0,0,0,7,18h6.4a2.4,2.4,0,0,0,2.4-2.4V6.8h.8a.8.8,0,1,0,0-1.6Zm-8-.8a.8.8,0,0,1,.8-.8H11a.8.8,0,0,1,.8.8v.8H8.6Zm5.6,11.2a.8.8,0,0,1-.8.8H7a.8.8,0,0,1-.8-.8V6.8h8Z',
		viewBox: '0 0 14.4 16',
		transform: 'translate(-3 -2)'
	},

	send: {
		d: 'M18.339,7.314l-14-7a3,3,0,0,0-4.08,3.9l2.4,5.37h0a1.06,1.06,0,0,1,0,.82l-2.4,5.37A3,3,0,0,0,3,19.994a3.14,3.14,0,0,0,1.35-.32l14-7a3,3,0,0,0,0-5.36Zm-.89,3.57-14,7a1,1,0,0,1-1.35-1.3l2.39-5.37a2,2,0,0,0,.08-.22h6.89a1,1,0,0,0,0-2H4.569a2,2,0,0,0-.08-.22L2.1,3.4a1,1,0,0,1,1.35-1.3l14,7a1,1,0,0,1,0,1.78Z',
		viewBox: '0 0 25.633 25.629',
		transform: 'translate(0 6.841) rotate(-20)'
	},

	clip: {
		d: 'M18.08,12.42,11.9,18.61a4.25,4.25,0,0,1-6-6l8-8a2.57,2.57,0,0,1,3.54,0,2.52,2.52,0,0,1,0,3.54l-6.9,6.89A.764.764,0,0,1,9.42,14l5.13-5.12a1,1,0,1,0-1.42-1.42L8,12.6a2.74,2.74,0,0,0,0,3.89,2.82,2.82,0,0,0,3.89,0l6.89-6.9a4.5,4.5,0,0,0-6.36-6.36l-8,8A6.25,6.25,0,0,0,13.31,20l6.19-6.18a1,1,0,1,0-1.42-1.42Z',
		viewBox: '0 0 17.179 19.646',
		transform: 'translate(-2.809 -2.022)'
	}
}

export default {
	props: {
		iconName: {
			type: String,
			default: ''
		},

		iconColor: {
			type: String,
			default: 'currentColor'
		}
	},

	computed: {
		icon () {
			return icons[this.iconName]
		}
	}
}
</script>

<style lang="scss" scoped>
.app-icon {
	display: inline-block;

	svg {
		width: 100%;
		height: 100%;
		pointer-events: none;
	}
}
</style>
